module.exports = __webpack_public_path__ + "static/media/plinklittle.9fa76991.png";